import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { RewardsTabManager } from "./components";
import { usePlayroomRewardsTranslations } from "./hooks";
import PlayroomHistory from "./sections/PlayroomHistory";
import PlayroomMarketplace from "./sections/PlayroomMarketplace";
import { jsx as _jsx } from "react/jsx-runtime";
export var PlayroomRewardsSection = function PlayroomRewardsSection(_ref) {
  var crehanaCoinsAvailable = _ref.crehanaCoinsAvailable,
    organizationSlug = _ref.organizationSlug,
    organizationId = _ref.organizationId,
    customCurrencyName = _ref.customCurrencyName,
    dataTestid = _ref['data-testid'],
    className = _ref.className,
    style = _ref.style,
    onRedeemError = _ref.onRedeemError,
    onRedeemSuccessProp = _ref.onRedeemSuccess;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    provisionalSelectedTabIndex = _useState2[0],
    setProvisionalSelectedTabIndex = _useState2[1];
  var onRedeemSuccess = useCallback(function (reward) {
    onRedeemSuccessProp(reward);

    // This is a hack to force the tab manager to change the selected tab to the "History"
    setProvisionalSelectedTabIndex(1);
    setTimeout(function () {
      // This is a hack to force the tab manager to reset state.
      setProvisionalSelectedTabIndex(undefined);
    }, 200);
  }, [onRedeemSuccessProp]);
  return /*#__PURE__*/_jsx(RewardsTabManager, {
    style: style,
    className: className,
    selectedTabIndex: provisionalSelectedTabIndex,
    "data-testid": dataTestid,
    tabs: [{
      label: t('PRS_TAB_MARKETPLACE'),
      defaultSelected: true,
      content: PlayroomMarketplace,
      props: {
        organizationSlug: organizationSlug,
        organizationId: organizationId,
        customCurrencyName: customCurrencyName,
        crehanaCoinsAvailable: crehanaCoinsAvailable,
        // This property is applied to tab
        'data-testid': 'playroom-marketplace',
        onRedeemError: onRedeemError,
        onRedeemSuccess: onRedeemSuccess
      }
    }, {
      label: t('PRS_TAB_HISTORY'),
      content: PlayroomHistory,
      props: {
        organizationSlug: organizationSlug,
        organizationId: organizationId,
        customCurrencyName: customCurrencyName,
        crehanaCoinsAvailable: crehanaCoinsAvailable,
        // This property is applied to tab
        'data-testid': 'playroom-rewards-history',
        onRedeemSuccess: onRedeemSuccess
      }
    }]
  });
};
export default PlayroomRewardsSection;